module["exports"] = [
  "Avon",
  "Bedfordshire",
  "Berkshire",
  "Borders",
  "Buckinghamshire",
  "Cambridgeshire"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/address/county.js
 ** module id = 283
 ** module chunks = 0
 **/